"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfWebP = exports.SUPPORTS_WEBP = void 0;
exports.SUPPORTS_WEBP = null;
/* istanbul ignore next */

exports.checkIfWebP = new Promise(function (resolve) {
  if (typeof Image === 'undefined') {
    resolve(false);
  }

  var webp = new Image();

  webp.onload = function () {
    exports.SUPPORTS_WEBP = true;
    resolve(exports.SUPPORTS_WEBP);
  };

  webp.onerror = function () {
    exports.SUPPORTS_WEBP = false;
    resolve(exports.SUPPORTS_WEBP);
  };

  webp.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
});